'use client'

import { useGetUserQuery } from '@/lib/features/user/userApi'
import { PAGE_PATH } from '@/lib/page-paths'
import { cn } from '@/lib/utils'
import { LayoutDashboard } from 'lucide-react'
import Link from 'next/link'

type DashboardButtonV2Props = {
  className?: string
}

export function DashboardButtonV2({ className }: DashboardButtonV2Props) {
  const { data: userData, isLoading: userLoading } = useGetUserQuery()
  const user = userData?.user

  if (userLoading) {
    return (
      <div className="hidden md:flex">
        <div
          className={cn(
            '!font-space-grotesk flex items-center space-x-2 rounded-[20px] bg-black p-[16px] text-[20px] font-normal leading-none tracking-wide text-white',
            className
          )}
        >
          <div className="h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent" />
          <span>Loading...</span>
        </div>
      </div>
    )
  }

  if (!user || user.isAnonymous) return null

  return (
    <div className="hidden md:flex">
      <Link
        href={PAGE_PATH.DASHBOARD}
        className={cn(
          '!font-space-grotesk flex items-center space-x-2 rounded-[20px] bg-black p-[16px] text-[20px] font-normal leading-none tracking-wide text-white transition-colors duration-200 hover:bg-[#454545]',
          className
        )}
      >
        <LayoutDashboard size={18} />
        <span>My apps</span>
      </Link>
    </div>
  )
}
